var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"invitation__skeleton--card"},[_c('div',{staticClass:"invitation__skeleton--card__title"}),_c('div',{staticClass:"invitation__skeleton--card__count"})])
}]

export { render, staticRenderFns }